<template>
    <game-list ref="gamelist" :provider="provider" :save="save" :sync="sync" :edit="edit" />
</template>
<script>
import gameService from '../../../../services/game.service';

import GameList from '../../../common/games-list.vue';

export default {
    name: 'client-games-list',
    components: { GameList },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        },
        provider() {
            return this.$route.params.provider;
        }
    },
    watch: {
        async clientId() {
            await this.loadGames();
        },
        async provider() {
            await this.loadGames();
        }
    },
    async mounted() {
        await this.loadGames();
    },
    methods: {
        async loadGames() {
            let games = await gameService.getClientGames(this.clientId, this.provider);
            this.$refs.gamelist.set(games);
        },
        async save(game) {
            await gameService.saveClientGame(game, this.clientId);
            await this.loadGames();
        },
        async sync() {
            await gameService.syncProviderGamesForClientAsync(this.clientId, this.provider);
            await this.loadGames();
        },
        async edit(game) {
            await gameService.saveGameProperties(game);
            await this.loadGames();
        }
    }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/games/list.vue